function showResortMapOnClick(resortMap) {
    const roomId = resortMap.dataset.id;
    const resortMapButton = document.querySelector('.resort-map-button[data-id="' + roomId + '"]');
    const overviewImage = resortMap.querySelector('.resort-map__image.resort-map__image--overview');
    const body = document.querySelector('body');

    if (!resortMap || !resortMapButton || !overviewImage) {
        return;
    }

    resortMapButton.addEventListener('click', function () {
        if (resortMap) {
            resortMap.classList.add('resort-map--open');
            body.classList.add('js-resort-map-open');
        }
    });

    const resortMapHeadIcons = resortMap.querySelectorAll('.resort-map__head .icon');

    if (!resortMapHeadIcons) {
        return;
    }

    resortMapHeadIcons.forEach(function (icon) {
        icon.addEventListener('click', function () {
            if (resortMap) {
                resortMap.classList.remove('resort-map--open');
                body.classList.remove('js-resort-map-open');
            }
        });
    });
}

const resortMaps = document.querySelectorAll('.resort-map');

resortMaps.forEach((resortMap) => {
    showResortMapOnClick(resortMap);
});
